import React from 'react'
import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'

const ChatWidget = React.lazy(() => import('./components/ChatWidget'))
const container = document.getElementById('chat-snap-in-widget')
const root = createRoot(container) // Create a root.

// Using React.StrictMode to help identify potential problems in the application.
// It activates additional checks and warnings for its descendants.
// Some of the checks performed by
// React.StrictMode :
// Identifying components with unsafe lifecycles
// Warning about legacy string ref API usage
// Warning about deprecated findDOMNode usage
// Detecting unexpected side effects
// Detecting legacy context API

root.render(
  <React.Suspense fallback={<div></div>}>
    <React.StrictMode>
      <ChatWidget />
    </React.StrictMode>
  </React.Suspense>
)
